module.exports = __webpack_public_path__ + "fonts/Inter-600-vietnamese43.74fe938.woff2";